// ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    let cancelled = false;
    const maxRetries = 8;
    const retryInterval = 60; // ms

    // Step 1: clear native scroll immediately to prevent browser flash
    // use 'auto' here so it jumps immediately
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    } catch (e) {
      // ignore in environments where window isn't available
    }

    // Step 2: try to use Lenis to set top (so it doesn't conflict with Lenis-controlled scroll)
    const tryLenis = (attempt = 0) => {
      if (cancelled) return;

      const l = (typeof window !== "undefined" && window.lenis) || null;

      if (l && typeof l.scrollTo === "function") {
        try {
          // immediate option when supported
          l.scrollTo(0, { immediate: true });
        } catch (err) {
          try {
            l.scrollTo(0);
          } catch (err2) {
            // safe fallback to native (already set once above)
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
          }
        }
        return;
      }

      if (attempt < maxRetries) {
        setTimeout(() => tryLenis(attempt + 1), retryInterval);
      } else {
        // final fallback (ensure top)
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      }
    };

    // small delay to let react paint the new route, then try Lenis
    const initialDelay = setTimeout(() => tryLenis(0), 20);

    return () => {
      cancelled = true;
      clearTimeout(initialDelay);
    };
  }, [pathname]);

  return null;
}





